<template>
  <div class="consulting-center">
   <div class="consulting-center__top">
      <img class="consulting-center__top__img" src="../assets/image/consultingCenter_1.png" alt="">
      <div class="consulting-center__top__text1">
        <p>打造“更加智能化”</p>
        <p>“用户体验更好”“更年轻化”的新品牌</p>
        </div>
      <div class="consulting-center__top__text2">
        <p>CREATE "MORE INTELLIGENT"</p>
        <p>A NEW BRAND WITH A "BETTER USER EXPERIENCE" AND A "YOUNGER AGE"</p>
      </div>
    </div>
    <div class="consulting-center__middle">
      <div class="consulting-center__middle__item" v-for="(item,index) in data" :key="index">
        <span>{{item.dateMonth}}</span>
        <div class="consulting-center__middle__item__container">
          <img :style="{width:'300px',height:'200px',marginTop:'15px'}" :src="item.imgUrl" alt="">
          <div class="consulting-center__middle__item__text">
            <p>{{item.title}}<span>{{item.exactDate}}</span></p>
            <div>
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgUrl2 from '../assets/image/consultingCenter_2.png'
import imgUrl3 from '../assets/image/consultingCenter_3.png'
import imgUrl4 from '../assets/image/consultingCenter_4.png'
import imgUrl5 from '../assets/image/consultingCenter_5.png'
export default {
  name: 'ConsultingCenter',
  data(){
    return {
      data:[
        {
          imgUrl:imgUrl2,
          dateMonth:'2021-06',
          exactDate:'2021-06',
          title:'新大洲电动车2021年度经销商厂商联合冲刺大会',
          text:'2021.06.28“决胜789，锁定120万”新大洲2021年度厂商联合冲刺大会，在无锡白金汉爵大酒店完美收官'
        },
        {
          imgUrl:imgUrl3,
          dateMonth:'2021-04',
          exactDate:'2021-04',
          title:'东风新能源全年营销服务项目合作签约',
          text:'本次与东风新能源合作签约，将从整体策略规划到执行战术全方位进行合作，同时对东风首款新能源EX1进行定位“全路况代步车”'
        },
        {
          imgUrl:imgUrl4,
          dateMonth:'2021-03',
          exactDate:'2021-03',
          title:'3·14新大洲高端智能电动新品牌“派”发布',
          text:'2021.3.14高端智能电动“派”新品牌发布，首款新车“派·D1”首次亮相。这是一场“为颠覆而来，为创新而生”的视觉盛宴，众多业内大咖、行业媒体、彩绘潮流设计师、年轻用户玩家，百万级KOL亲临现场，一同见证“派·无止境”新品上市暨品牌发布会。'
        },
        {
          imgUrl:imgUrl5,
          dateMonth:'2021-02',
          exactDate:'2021-02',
          title:'新大洲电动车数字营销服务签约',
          text:'本次与新大洲电动车合作签约，将从策略到执行进行深度营销服务合作，对上海、无锡、天津产品线梳理及组合规划，产品命名规划制定及产品定位规划。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.consulting-center{
  &__top{
    position: relative;
    width: 100%;
    &__img{
      width: 100%;
      min-width: 1440px;
      max-width: 1920px;
    }
    &__text1{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 40px;
      top: 280px;
      line-height: 50px;
    }
    &__text2{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #F8F8F8;
      font-size: 15px;
      top: 380px;
      line-height: 24px;
      letter-spacing:3px;
    }
  }
  &__middle{
    width: 1440px;
    margin: 0px auto;
    &__item{
      border-left: 1px solid #0248EE;
      padding: 65px 0px 0px 180px;
      position: relative;
      &:first-child{
        padding-top: 85px;
      }
      &:last-child{
        padding-bottom: 85px;
      }
      &>span{
        position: absolute;
        left: 20px;
        top: 15px;
        &::after{
          content: "";
          display: inline-block;
          position: absolute;
          bottom: 0px;
          left: -22px;
          width: 3px;
          height: 14px;
          background: #409eff;
        }
      }
      &__container{
        width: 100%;
        display: flex;
      }
      &__text{
        width: 100%;
        padding: 20px 30px;
        p{
          display: flex;
          justify-content: space-between;
          color: #333;
          font-size: 20px;
          span{
            font-size: 12px;
            color: #999;
          }
        }
        div{
          line-height: 28px;
          margin-top: 30px;
          text-align: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/consultingCenter.vue